import React from 'react';
import { useApi } from '../../hooks/useApi';
import { useAuthUserContext } from '../../providers';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface WithdrawConfirmModalProps {
  hideModal: () => void;
  isDonee: boolean;
}

const WithdrawConfirmModal = (props: WithdrawConfirmModalProps) => {
  const { hideModal, isDonee } = props;
  const { get } = useApi();
  const { user, signout } = useAuthUserContext();
  const navigate = useNavigate();

  const handleWithdraw = () => {
    if (!user?.userId) return;
    get({
      endpoint: `api/v1/users/${user.userId}/cancel`,
      onSuccess: () => {
        signout(() => {
          navigate('/');
          toast.success('退会処理が完了しました。ご利用ありがとうございました。');
        });
      },
      onError: () => {
        toast.error('退会処理に失敗しました。時間をおいて再度お試しください。');
        hideModal();
      },
    });
  };

  return (
    <section className="modalarea">
      <div className="modalbg" onClick={ hideModal }></div>
      <div className="modalwrapper">
        <div>
          <h2 className="sec_title">退会確認</h2>
          <p>
            退会すると全ての登録情報が削除されます。<br/>
            退会しますか？
          </p>
          <ul className="btnarea">
            <li>
              <button className="orangebtn" onClick={ handleWithdraw }>
                はい、退会します
              </button>
            </li>
            <li>
              <button className={ isDonee ? "w_pinkbtn" : "w_bluebtn" } onClick={ hideModal }>
                いいえ
              </button>
            </li>
          </ul>
          <div className="closemodal" onClick={ hideModal }>×</div>
        </div>
      </div>
    </section>
  );
};

export default WithdrawConfirmModal; 
